import type { AgentInstance, WorkflowInstance } from '@/types/agent';

/**
 * Finds the AgentInstance matching the given agent short name.
 */
export function findAgentInstanceByShortName(
  agentInstances: AgentInstance[],
  agentShortName: string
): AgentInstance | undefined {
  return agentInstances.find(
    (instance) => instance.agent.short_name === agentShortName
  );
}

/**
 * Finds the primary workflow instance for an agent instance.
 * The primary workflow instance is identified by having workflow.short_name === null.
 */
export function findPrimaryWorkflowInstance(
  agentInstance: AgentInstance | null | undefined
): WorkflowInstance | undefined {
  return agentInstance?.workflow_instances?.find(
    (instance) => instance.workflow.short_name === null
  );
}

/**
 * Resolves the primary workflow_instance_id for a given agent short name.
 *
 * Two-step lookup:
 * 1. Find the AgentInstance matching the agent_short_name
 * 2. Find the primary WorkflowInstance (where workflow.short_name === null)
 */
export function resolveWorkflowInstanceId(
  agentInstances: AgentInstance[],
  agentShortName: string
): string | undefined {
  const agentInstance = findAgentInstanceByShortName(agentInstances, agentShortName);
  if (!agentInstance) return undefined;

  const workflowInstance = findPrimaryWorkflowInstance(agentInstance);
  return workflowInstance?.id;
}
